export const TOKEN_CURRENT = 'TOKEN_CURRENT'
export const ROLE_ID = 'ROLE_ID'

export const _ = undefined
